import { render, staticRenderFns } from "./FormElementPhone.vue?vue&type=template&id=b7cbb55e"
import script from "./FormElementPhone.vue?vue&type=script&lang=js"
export * from "./FormElementPhone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports